import IconShare from '@picsart/icons/IconShare';
import classNames from 'classnames';
import { useState } from 'react';

import { getPageName } from '../../../../utils/widgets/shareWidget';
import BaseShareModal from '../BaseShareModal';

import useStyles from './styles';
import { IShareButton } from './types';

function ShareButton({ toolName, className, analytics, redirectUrl, widgetUrl }: IShareButton) {
  const [showModal, setShowModal] = useState(false);
  const classes = useStyles();

  const handleOnClick = () => {
    const pageName = getPageName();
    analytics.shareOpen(pageName);
    setShowModal(true);
  };

  return (
    <>
      <div className={classes.buttonContainer}>
        <button className={classNames(classes.button, className)} onClick={handleOnClick}>
          <IconShare className={classes.svgIcon} />
        </button>
      </div>

      <BaseShareModal
        redirectUrl={redirectUrl}
        toolName={toolName}
        showModal={showModal}
        setShowModal={setShowModal}
        analytics={analytics}
        widgetUrl={widgetUrl}
      />
    </>
  );
}
export default ShareButton;
